"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var find_1 = tslib_1.__importDefault(require("lodash/fp/find"));
var Select_1 = require("../Select");
var utils_1 = require("./utils");
var TimePicker = function (_a) {
    var _b;
    var onChange = _a.onChange, value = _a.value, _c = _a.header, header = _c === void 0 ? '' : _c, _d = _a.interval, interval = _d === void 0 ? 60 : _d, _e = _a.startHour, startHour = _e === void 0 ? 0 : _e, _f = _a.endHour, endHour = _f === void 0 ? 24 : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g, className = _a.className, rest = tslib_1.__rest(_a, ["onChange", "value", "header", "interval", "startHour", "endHour", "disabled", "className"]);
    var options = react_1.useMemo(function () {
        return utils_1.buildTimeOptions(interval, startHour, endHour);
    }, [interval, startHour, endHour]);
    var timeValue = (_b = find_1.default({ label: value }, options)) !== null && _b !== void 0 ? _b : options[0];
    var handleChange = react_1.useCallback(function (_a) {
        var label = _a.label;
        return onChange(label);
    }, [onChange]);
    return (react_1.default.createElement(StyledTimePickerContainer, { className: className },
        header && (react_1.default.createElement(StyledLabel, { disabled: disabled, role: "heading" }, header)),
        react_1.default.createElement(StyledSelectContainer, null,
            react_1.default.createElement(StyledSelect, tslib_1.__assign({ isDisabled: disabled, options: options, value: timeValue, onChange: handleChange }, rest)))));
};
TimePicker.displayName = 'FOS_TimePicker';
exports.default = TimePicker;
var StyledTimePickerContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var StyledSelectContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var StyledSelect = styled_components_1.default(Select_1.Select)(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  width: 100%;\n  min-width: 110px;\n"], ["\n  width: 100%;\n  min-width: 110px;\n"])));
var StyledLabel = styled_components_1.default.span(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  display: block;\n  margin-bottom: 1rem;\n  font-size: 13px;\n  font-family: ", " !important;\n  color: ", " !important;\n  opacity: ", ";\n"], ["\n  display: block;\n  margin-bottom: 1rem;\n  font-size: 13px;\n  font-family: ", " !important;\n  color: ", " !important;\n  opacity: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.robotoMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[700];
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.3 : 1);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
